module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-office-banner"
  }, [_c('TitleTrigger', {
    staticClass: "custom-office-banner__title-trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-office-banner__container"
  }, [_c('div', {
    staticClass: "custom-office-banner__title",
    class: {
      active: this.titleActive
    }
  }, [_vm._v(_vm._s(_vm.props.title_1)), _c('div', {
    staticClass: "custom-office-banner__fancy-a"
  }, [_c('Icon', {
    attrs: {
      "name": _vm.props.icon
    }
  })], 1), _c('div', {
    staticClass: "custom-office-banner__title--2"
  }, [_vm._v("- " + _vm._s(_vm.props.title_2))]), _c('div', {
    staticClass: "custom-office-banner__title--3"
  }, [_vm._v(_vm._s(_vm.props.title_2))])])]), _c('div', {
    staticClass: "custom-office-banner__container"
  }, [(_vm.props.body) ? _c('div', {
    staticClass: "custom-office-banner__body",
    class: {
      active: this.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484f245a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-office-banner/custom-office-banner.pug
// module id = 636
// module chunks = 1